import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {RootState} from '../RootState';
import axios from "axios";
import {settings} from "@/plugins/settings";
import responseHandler from "@/plugins/errorHandling";
import {IListSshConnection} from "@/model/SshConnections/sshConnectionInterfaces";

interface SshConnectionState {
  sshConnectionList: IListSshConnection[];
}

const state: SshConnectionState = {
    sshConnectionList: [],
};

const getters: GetterTree<SshConnectionState, RootState> = {
  sshConnectionsList: (state): IListSshConnection[] => state.sshConnectionList,
};

const actions: ActionTree<SshConnectionState, RootState> = {
  fetchSshConnections: ({commit}, { filters}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'standalones/sshconnections',
      method: 'GET',
      params: filters,
    }),
    commit,
        'sshConnectionsLoaded',
  ),
};

const mutations: MutationTree<SshConnectionState> = {
  sshConnectionsLoaded(state, payload: any) {
    state.sshConnectionList = payload;
  },
};

const namespaced: boolean = true;

export const sshConnectionModule: Module<SshConnectionState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
